/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_EuInputs */

const en_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU`)
};

const es_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU`)
};

const fr_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UE`)
};

const de_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU`)
};

const ja_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU`)
};

const zh_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欧码 (EU)`)
};

const ar_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أوروبي (EU)`)
};

const id_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU`)
};

const it_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU`)
};

const ru_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU`)
};

const pt_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU`)
};

const ko_val_eu = /** @type {(inputs: Val_EuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU (유럽 사이즈)`)
};

/**
* | output |
* | --- |
* | "EU" |
*
* @param {Val_EuInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_eu = /** @type {((inputs?: Val_EuInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_EuInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_eu(inputs)
	if (locale === "es") return es_val_eu(inputs)
	if (locale === "fr") return fr_val_eu(inputs)
	if (locale === "de") return de_val_eu(inputs)
	if (locale === "ja") return ja_val_eu(inputs)
	if (locale === "zh") return zh_val_eu(inputs)
	if (locale === "ar") return ar_val_eu(inputs)
	if (locale === "id") return id_val_eu(inputs)
	if (locale === "it") return it_val_eu(inputs)
	if (locale === "ru") return ru_val_eu(inputs)
	if (locale === "pt") return pt_val_eu(inputs)
	return ko_val_eu(inputs)
});